
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#fff","xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.25 2.49v-.24a.75.75 0 011.5 0v.24H10A1.48 1.48 0 0111.54 4h.51a1.47 1.47 0 011.48 1.46v1.48c.32.15.51.29.51.41A6.89 6.89 0 0113 10.26v2.08a3.09 3.09 0 01-.53 0 3.33 3.33 0 01-1.4-.27l-.46-.23a1.48 1.48 0 00-.58-.14h-.16a1.56 1.56 0 00-.5.17L9 12.1a2 2 0 01-1 .26 1.79 1.79 0 01-1-.25L6.76 12a1.51 1.51 0 00-.28-.15 1.33 1.33 0 00-.48-.1h-.06a1.42 1.42 0 00-.56.15l-.47.21a3.29 3.29 0 01-1.41.28 4.1 4.1 0 01-.5 0v-2.14a7.09 7.09 0 01-1-2.9c0-.12.19-.27.5-.42V5.46A1.51 1.51 0 014 4h.54C4.67 3 5.18 2.49 6 2.49zm5.28 4.05V5.43a.47.47 0 00-.48-.43h-.51a1 1 0 01-1-.86c-.06-.48-.2-.63-.51-.63H6c-.28 0-.41.15-.47.62a1 1 0 01-1 .87H4a.5.5 0 00-.51.5v1.02A22.39 22.39 0 018 5.45a23.4 23.4 0 014.55 1.09zM4.26 8.88A.73.73 0 005 8.14a.75.75 0 00-1.5 0 .75.75 0 00.75.74zm7.52 0a.73.73 0 00.75-.73.75.75 0 00-1.5 0 .75.75 0 00.75.74zm-5.67 5h-.09a.6.6 0 00-.22.06l-.47.22a4.39 4.39 0 01-1.82.37 5 5 0 01-2.78-.74.48.48 0 01-.15-.67.51.51 0 01.7-.14 4 4 0 002.23.57 3.36 3.36 0 001.42-.28L5.4 13a1.61 1.61 0 01.6-.14 1.19 1.19 0 01.49.1l.28.15.24.14a1.79 1.79 0 001 .26 2 2 0 001-.27l.41-.24a1.48 1.48 0 01.5-.17H10a1.32 1.32 0 01.58.15l.47.22a3.33 3.33 0 001.4.28 4 4 0 002.24-.57.5.5 0 01.69.14.49.49 0 01-.14.68 5 5 0 01-2.78.74 4.23 4.23 0 01-1.81-.37l-.48-.23a.43.43 0 00-.16-.05.44.44 0 00-.16.06l-.37.2A3 3 0 018 14.5a2.8 2.8 0 01-1.45-.38c-.14-.12-.29-.12-.44-.25z"}})])
          )
        }
      }
    